global.debug = false;
global.statusConexao = navigator.onLine;

//global.url ="http://localhost:8000/";
// global.url = "https://sandbox.wavecode.com.br/";  // DEV SERVER
global.url = process.env.REACT_APP_API || "https://api.wavecode.com.br/"; // PROD SERVER
// global.url = "http://127.0.0.1:8000/"; //HTTPS SSL
